<template>
  <div class="ec-banner-ad-page">
    <el-table ref="multipleTable" size="small" :data="ecBannerAd.list" style="width: 100%; margin-top:20px;">
      <el-table-column prop="ecBannerAdItem.name" label="广告位" width="200">
        <template v-slot="{row: { ecBannerAdItem } }">
          <div v-if="ecBannerAdItem.name === '活动详情页面'" class="flex" style="align-items: center;">
            <div style="margin-right: 10px;">活动详情页面</div>
            <el-popover placement="bottom-start" width="410" trigger="hover">
              <i slot="reference" class="el-icon-warning-outline" style="font-size: 24px;" />
              <div>活动详情页包含：</div>
              <div>UA STAR+训练营+打卡+个人挑战赛+好友PK赛+跑步+骑行</div>
            </el-popover>
          </div>
          <span v-else>{{ ecBannerAdItem.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ecBannerAdItem.imageUrl" label="广告图片" min-width="360">
        <template v-slot="{row: { ecBannerAdItem } }">
          <UploadImage :show-replace="false" :limit-size="5" :url="ecBannerAdItem.imageUrl" :save-path="'ecAdvertecAdvert/banner/'" size-tips="1005*503px" @upload="handleImgUP($event,ecBannerAdItem)" />
        </template>

      </el-table-column>
      <el-table-column prop="ecBannerAdItem.title" label="标题" min-width="450">
        <template v-slot="{row: { ecBannerAdItem } }">
          <div class="flex" style="align-items: center;">
            <div style="white-space: nowrap; margin-right: 30px;">标题</div>
            <el-input v-model="ecBannerAdItem.title" placeholder="请输入标题" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ecBannerAdItem.linkUrl" label="跳转链接" min-width="450">
        <template v-slot="{row: { ecBannerAdItem } }">
          <div class="flex" style="align-items: center;">
            <div style="white-space: nowrap; margin-right: 30px;">链接地址</div>
            <el-input v-model="ecBannerAdItem.linkUrl" placeholder="请填写banner跳转地址链接" />
          </div>
        </template>
      </el-table-column>
      <el-table-column width="444" label="操作">
        <template v-slot="{row}">
          <el-button v-if="row.ecBannerAdItem.imageUrl || row.ecBannerAdItem.linkUrl" size="small" type="primary" @click="reset(row)">重置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex btns">
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
import UploadImage from './uploadImage.vue';
import { ECBannerAd } from '@/model/ECBannerAd';
export default {
  components: { UploadImage },
  data() {
    return {
      ecBannerAd: new ECBannerAd(),
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.$Api.ecBannerAd.postECBannerAD({
        segment: 'ec_banner_advertisement',
      }).then(res => {
        if (res && res?.length) {
          this.ecBannerAd = new ECBannerAd(res);
        }
      });
    },
    handleImgUP(file, ecBannerAdItem) {
      ecBannerAdItem.imageUrl = file;
      console.log(file, ecBannerAdItem);
    },
    reset(row) {
      row.ecBannerAdItem.imageUrl = "";
      row.ecBannerAdItem.linkUrl = "";
      console.log(row);
    },
    submit() {
      this.$Api.ecBannerAd.updateECBannerAD(this.ecBannerAd.list).then(res => {
        console.log('res', res);
        this.$message.success('保存成功');
        this.fetchList();
      });
      console.log(this.ecBannerAd);
    },
  },
};
</script>

<style lang="less" scoped>
.ec-banner-ad-page {
  position: relative;

  padding: 30px;

  background: #fff;
  .btns {
    justify-content: center;

    margin-top: 30px;
  }
  :deep(.el-table) {
    .is-leaf.el-table__cell {
      border-bottom: none !important;
      background: #fff !important;
      &:first-of-type {
        padding-left: 50px;
      }
    }
    .el-table__body {
      border-spacing: 0px 30px;

      border-collapse: separate;
      .el-table__row {
        background: #f7f7f7 !important;

        .el-table__cell {
          height: 232px !important;

          border-bottom: none;
          &:first-of-type {
            padding-left: 50px;
          }
        }
      }
    }
  }
}
</style>
